import { render, staticRenderFns } from "./lotto-detail.vue?vue&type=template&id=cdb00418&scoped=true&"
import script from "./lotto-detail.vue?vue&type=script&lang=js&"
export * from "./lotto-detail.vue?vue&type=script&lang=js&"
import style0 from "./lotto-detail.vue?vue&type=style&index=0&id=cdb00418&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb00418",
  null
  
)

export default component.exports